import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { KYMW1400KomaMediumComboBoxComponent } from './kymw1400-koma-medium-combo-box.component';
import { GetKomaMediumListService } from '../api-services/get-koma-medium-list.service';



/**
 * コマ割（共通ページ） モジュール設定クラス
 *
 * @export KYMW1400KomaPageModule
 * @class KYMW1400KomaPageModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1400KomaMediumComboBoxComponent,
  ],
  providers: [],
  exports: [
    KYMW1400KomaMediumComboBoxComponent,
  ]
})
export class KYMW1400KomaMediumComboBoxModule {
}
